import React from 'react';
import styled, { css } from 'styled-components';
// import colors from '../../../vars/colors';
import breakpoints from '../../../vars/breakpoints';
// import gutters from '../../../vars/gutters';


export const VideoPlayer = styled.div`
    .ui-holder {
        cursor: pointer;
        .ui-button {
            opacity: 1;
            transition: opacity 300ms ease-in-out;
        }
        &.playing {
            .ui-button {
                opacity: 0;
            }
            &:hover {
                .ui-button {
                    opacity: 1;
                }
            }
            @media (max-width: ${breakpoints['bp-mobile']}) {
                &:hover {
                    .ui-button {
                        opacity: 0;
                    }
                }
            }
        }
    }
`
;


// WEBPACK FOOTER //
// ./src/components/global/media/styled-components.js